import React, { useState, useEffect, useContext } from 'react';
import { isOnline, OFFLINE_RESTRICTED_ACTIONS } from '../utils/offlineManager';
import OfflineNotification from '../components/OfflineNotification';
import { IonHeader, IonToolbar, IonContent, IonPage, IonButtons, IonMenuButton, IonButton, IonIcon, IonDatetime, IonSelectOption, IonList, IonItem, IonLabel, IonSelect, IonPopover, IonText, IonCard, IonCardHeader, IonCardContent, IonCardSubtitle, IonCardTitle, IonCol, IonGrid, IonRow, IonAvatar, IonToast, IonTitle } from '@ionic/react';
import './About.scss';
import QRCode from "qrcode";
import { ellipsisHorizontal, ellipsisVertical, qrCode, scan, share } from 'ionicons/icons';
import AboutPopover from '../components/AboutPopover';
import { connect } from '../data/connect';
// import { format, parseISO } from 'date-fns';
import { Redirect } from 'react-router';
import QrScanner from '../components/QrScanner';
import ScannedBadge from '../components/ScannedBadge';
import NetworkingContactModal from '../components/NetworkingContactModal';
import NetworkingService from '../services/NetworkingService';
import { isFeatureEnabled } from '../config/app.config';



interface StateProps {
  username?: string;
  userced?: string;
  userother?: string;
  eventcode?: string;
}



interface AboutProps extends StateProps { }

const About: React.FC<AboutProps> = ({ username, userced, userother, eventcode }) => {


  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState<MouseEvent>();
  const [location, setLocation] = useState<'madison' | 'austin' | 'chicago' | 'seattle'>('madison');
  const [conferenceDate, setConferenceDate] = useState('2047-05-17T00:00:00-05:00');
  const [showScanner, setShowScanner] = useState(false);
  const [showScannedBadge, setShowScannedBadge] = useState(false);
  const [scannedData, setScannedData] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [showOfflineNotification, setShowOfflineNotification] = useState(false);
  const [offlineAction, setOfflineAction] = useState('');
  const [networkingContact, setNetworkingContact] = useState<any>(null);
  const [qrDataUrl, setQrDataUrl] = useState<string>('');
  const [showNetworkingContact, setShowNetworkingContact] = useState(false);

   //const isLoggedin = username.length;
   //console.log(username);

  const selectOptions = {
    header: 'Select a Location'
  };
  const presentPopover = (e: React.MouseEvent) => {
    setPopoverEvent(e.nativeEvent);
    setShowPopover(true);
  };

  // Efecto para asegurar que el escáner se desactive al desmontar el componente
  useEffect(() => {
    return () => {
      // Limpieza al desmontar - asegurarse de que el escáner esté cerrado
      setShowScanner(false);
      setShowScannedBadge(false);
    };
  }, []);

  // Efecto para generar el QR code
  useEffect(() => {
    const generateQR = async () => {
      try {
        const qrValue = generateQRValue();
        const qrDataUrl = await QRCode.toDataURL(qrValue, {
          width: 220,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
        setQrDataUrl(qrDataUrl);
      } catch (error) {
        console.error('Error generating QR code:', error);
      }
    };

    generateQR();
  }, [username, userced, eventcode]); // Regenerar cuando cambien los datos del usuario

  const handleScanClick = () => {
    console.log('Activando escáner QR');

    // Verificar si hay conexión a internet
    if (isOnline()) {
      setShowScanner(true);
    } else {
      // Mostrar notificación de que esta acción requiere conexión
      setOfflineAction(OFFLINE_RESTRICTED_ACTIONS.SCAN_QR);
      setShowOfflineNotification(true);
      console.log('No se puede escanear QR sin conexión a internet');
    }
  };

  const handleScanSuccess = async (decodedText: string) => {
    console.log('QR escaneado con éxito:', decodedText);

    // Cerrar el escáner primero
    setShowScanner(false);

    // Verificar si es un QR de networking
    if (isFeatureEnabled('networking') && await isNetworkingQR(decodedText)) {
      console.log('QR de networking detectado');
      await handleNetworkingQR(decodedText);
    } else {
      // Es un QR de gafete normal
      console.log('QR de gafete normal detectado');
      setScannedData(decodedText);
      setShowScannedBadge(true);
      setToastMessage('Gafete escaneado correctamente');
      setShowToast(true);
    }
  };

  // Función para verificar si es un QR de networking
  const isNetworkingQR = async (qrContent: string): Promise<boolean> => {
    // Si networking está habilitado, todos los QRs son potencialmente de networking
    // (ya que ahora usan el mismo formato: cédula)
    return isFeatureEnabled('networking') && qrContent.trim().length > 0;
  };

  // Función para manejar QRs de networking
  const handleNetworkingQR = async (qrContent: string) => {
    try {
      const networkingService = NetworkingService.getInstance();
      const scannedProfile = await networkingService.processScannedQR(qrContent);

      // Mostrar información del contacto escaneado
      setNetworkingContact(scannedProfile);
      setShowNetworkingContact(true);
      setToastMessage(`¡Contacto agregado! ${scannedProfile.name}`);
      setShowToast(true);

      console.log('Contacto de networking agregado:', scannedProfile);
    } catch (error) {
      console.error('Error al procesar QR de networking:', error);
      setToastMessage(error instanceof Error ? error.message : 'Error al procesar el contacto');
      setShowToast(true);
    }
  };

  // Función para generar el valor del QR
  const generateQRValue = (): string => {
    // Siempre usar cédula (tanto para gafete como para networking)
    return userced || '';
  };

  const handleScannerClose = () => {
    console.log('Cerrando escáner QR');
    // Forzar el cierre del modal
    setShowScanner(false);

    // Asegurar que el estado se actualice inmediatamente
    setTimeout(() => {
      if (showScanner) {
        console.log('Forzando cierre del escáner QR');
        setShowScanner(false);
      }
    }, 100);
  };

  const handleScannedBadgeClose = () => {
    console.log('Cerrando modal de gafete escaneado');
    setShowScannedBadge(false);
  };

  function displayDate(date: string, dateFormat: string) {
    return date;
  }

  // Si no hay usuario, redirigir a login
  if (!username) {
    return <Redirect to="/login" />;
  }

  return (
    <IonPage id="about-page">
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>Mi Gafete</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={presentPopover}>
              <IonIcon slot="icon-only" ios={ellipsisHorizontal} md={ellipsisVertical}></IonIcon>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent className="ion-padding">

        {/* Digital Badge Card - Based on reference UI */}
        <IonCard className="digital-badge-card rounded-lg shadow-md ion-text-center my-4 mx-3 transition hover-up" style={{ background: 'white', border: '1px solid var(--neutral-200)' }}>
          <IonCardHeader className="badge-header ion-text-center">
            <IonAvatar className="badge-avatar">
              <img src="/assets/img/ica-slidebox-img-1.png" alt="Profile" />
            </IonAvatar>

            {username && (
              <IonText>
                <h2 className="badge-name" style={{ color: 'var(--neutral-900)', fontWeight: '600' }}>{username}</h2>
                <p className="badge-role" style={{ color: 'var(--neutral-700)' }}>{userother?.split("&&&")[0]}</p>
              </IonText>
            )}

            {username === undefined && <Redirect to="/login" />}
          </IonCardHeader>

          <IonCardContent>
            {/* Badge type/category */}
            <div className="badge-category ion-margin-vertical">
              <IonText>
                <div className="ion-padding" style={{borderRadius: '50px', background: 'var(--app-button-gradient)', color: 'white', fontWeight: '600', letterSpacing: '0.5px', textShadow: '0 1px 2px rgba(0,0,0,0.2)'}}>
                  {userother?.split("&&&")[1]}
                </div>
              </IonText>
            </div>

            {/* QR Code */}
            <div className="qr-container ion-padding ion-margin-vertical" style={{ background: 'white', borderRadius: '12px', border: '1px solid var(--neutral-200)', boxShadow: 'var(--shadow-sm)' }}>
              {qrDataUrl && (
                <img
                  src={qrDataUrl}
                  alt="QR Code"
                  style={{ maxWidth: "100%", height: "auto", width: "180px" }}
                />
              )}
            </div>

            {/* Scan button */}
            <IonButton
              expand="block"
              className="ion-margin-top" style={{ '--background': 'linear-gradient(135deg, #2a3b80, #3b68ff)', '--color': 'white', '--border-radius': '50px', fontWeight: '600' }}
              onClick={handleScanClick}
            >
              <IonIcon slot="start" icon={scan}></IonIcon>
              Escanear QR
            </IonButton>
          </IonCardContent>
        </IonCard>

      </IonContent>

      <IonPopover
        isOpen={showPopover}
        event={popoverEvent}
        onDidDismiss={() => setShowPopover(false)}
      >
        <AboutPopover dismiss={() => setShowPopover(false)} />
      </IonPopover>

      {/* Componente de escáner QR */}
      <QrScanner
        isOpen={showScanner}
        onClose={handleScannerClose}
        onScanSuccess={handleScanSuccess}
        userId={username} // Pasar el ID del usuario
        userCed={userced} // Pasar la cédula del usuario
        eventCode={eventcode} // Pasar el código del evento
        sendAttendance={true} // Enviar datos de asistencia para gafetes
        title="Escáner de Gafetes"
      />

      {/* Componente para mostrar el gafete escaneado */}
      <ScannedBadge
        isOpen={showScannedBadge}
        onClose={handleScannedBadgeClose}
        scannedData={scannedData}
      />

      {/* Modal para mostrar contacto de networking */}
      <NetworkingContactModal
        isOpen={showNetworkingContact}
        onClose={() => setShowNetworkingContact(false)}
        contact={networkingContact}
      />

      {/* Toast para mostrar mensajes */}
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={toastMessage}
        duration={2000}
        position="bottom"
        color="success"
        cssClass="glass-effect"
      />

      {/* Notificación para acciones que requieren conexión */}
      <OfflineNotification
        isOpen={showOfflineNotification}
        onDidDismiss={() => setShowOfflineNotification(false)}
        actionName={offlineAction}
        duration={3000}
      />
    </IonPage>
  );
};

//export default React.memo(About);

export default connect< StateProps>({
  mapStateToProps: (state) => ({
    username: state.user.username,
    userced: state.user.userced,
    userother: state.user.userother,
    eventcode: state.user.eventcode
  }),
  component: About
})